import {
  API_ENDPOINT,
  WANTED_STATIC_ENDPOINT_COMPANY,
  WANTED_WD_ENDPOINT,
} from '@/config/endpoint';
import { BLUR_URL, imageOpt } from '@/utils/images';
import { Box, Flex, Stack, Text } from '@mantine/core';

import { Badge } from '@/components/Badge';
import BookmarkButton from '@/components/Buttons/BookmarkButton';
import Image from 'next/image';
import Toast from '@/components/Toast';
import { addRefParam } from '@/utils/utils';
import { memo } from 'react';
import { messages } from '@/consts/Messages';
import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';
import { useTechstackDetailJobpostStyle } from './TechstackDetailJobpost';

const TechstackJobCard = ({ jobpost }) => {
  const { classes } = useTechstackDetailJobpostStyle();

  const handleBookmark = (jobpost_id, isBookmarked) => {
    mixpanelTrack('JobPostListPage_BookmarkButton', 'Clicked', {
      id: jobpost_id,
      is_bookmarked: isBookmarked,
    });

    if (isBookmarked) {
      API_ENDPOINT.recruits.deleteBookmark(jobpost_id).then(() => {
        Toast.error(messages.BOOKMARK_DELETED_SUCCESSFUL);
      });
    } else {
      API_ENDPOINT.recruits.addBookmark(jobpost_id).then(() => {
        Toast.success(messages.BOOKMARK_ADDED_SUCCESSFUL);
      });
    }
  };

  return (
    <Stack
      className={classes.jobpostCardWrapper}
      onClick={() => {
        mixpanelTrack('JobPostListPage_JobPostCard', 'Clicked', {
          id: jobpost.id,
        });
        window.open(
          addRefParam(`${WANTED_WD_ENDPOINT}/${jobpost.wd_id}`),
          '_blank'
        );
      }}
    >
      <Box pos={'relative'} h={200}>
        <Image
          fill
          sizes={`${themeVariables.layout.mobile} 100vw`}
          className={classes.headerImage}
          src={imageOpt(
            `${WANTED_STATIC_ENDPOINT_COMPANY}/${jobpost.company.title_img}`,
            720
          )}
          placeholder={'blur'}
          blurDataURL={BLUR_URL}
          alt="thumbnail"
          priority
        />
        <Box className={classes.imageOverlay} />
        <Box pos={'absolute'} top={4} right={6}>
          <BookmarkButton
            color={'white'}
            active={jobpost.is_bookmarked}
            onClick={() => handleBookmark(jobpost.id, jobpost.is_bookmarked)}
          />
        </Box>
      </Box>
      <Box>
        <Text
          size={13}
          weight={500}
          color={themeVariables.fontColors.light}
          mb={2}
        >
          {jobpost.company.name}
        </Text>
        <Text
          size={16}
          weight={600}
          color={themeVariables.fontColors.extraDark}
        >
          {jobpost.position}
        </Text>
      </Box>
      <Flex mt={6} gap={6} wrap={'wrap'}>
        {jobpost.techstacks.map((item) => (
          <Badge key={item.id} text={item.name || ''} />
        ))}
      </Flex>
    </Stack>
  );
};

export default memo(TechstackJobCard);
